var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gallery_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.522,
    height: 14.609,
    x: 0.609,
    y: 0.652,
    stroke: "currentColor",
    strokeWidth: 1.304,
    rx: 2.826
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.348,
    height: 3.478,
    x: 0.305,
    y: 18.522,
    fill: "currentColor",
    rx: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.348,
    height: 3.478,
    x: 5.522,
    y: 18.522,
    fill: "currentColor",
    rx: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.348,
    height: 3.478,
    x: 10.739,
    y: 18.522,
    fill: "currentColor",
    rx: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.348,
    height: 3.478,
    x: 15.957,
    y: 18.522,
    fill: "currentColor",
    rx: 0.87
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.348,
    height: 3.478,
    x: 21.174,
    y: 18.522,
    fill: "currentColor",
    rx: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gallery_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h26v22H0z"
  })))));
};
export default SvgGallery;